import History from "../../components/History";
function HistoryPage() {
  return <History />;
}

export default HistoryPage;
